const BASE_URL = process.env.NODE_ENV === 'production' ? 'https://artlensgroup.com' : 'https://test.artlensgroup.com'
// const BASE_URL = 'http://localhost:8000'
const IMAGE_URL = 'https://images.artlensgroup.com'
const API_BASE_URL = `${BASE_URL}/api/v1`

export {
    BASE_URL,
    IMAGE_URL,
    API_BASE_URL
}
